<template>
  <div class="card-info">
    <div>
      <div
        v-if="payment_status?.company_bounty_status != 'done'"
        class="d-flex align-self-start h-profile"
      >
        <div class="d-flex w-100 align-items-center">
          <div
            class="d-flex flex-row justify-content-between align-items-start w-100"
          >
            <p>
              <a class="mr-1 title-card">bughunt</a>
              <font class="description-status" v-text="$ml.get('awaitingPayment')"
                >aguardando pagamento</font
              >&nbsp;
              <img
                src="../../../src/assets/icons/long-arrow-right.svg"
                class="ico-15"
              />
              <a class="title-card">{{
                $utils.convertMoney(payment_status?.bounty_value)
              }}</a>
            </p>
          </div>
        </div>
      </div>
      <div
        v-if="payment_status?.company_bounty_status == 'done'"
        class="d-flex align-self-start h-profile mb-3"
      >
        <div class="d-flex w-100 align-items-center">
          <div
            class="d-flex flex-row justify-content-between align-items-start w-100"
          >
            <p>
              <span class="mr-1 title-card">bughunt</span>
              <span class="description-status mr-1" v-text="$ml.get('paymentReceived')" >recebeu o pagamento &nbsp; </span>
              <img
                src="../../../src/assets/icons/long-arrow-right.svg"
                class="ico-15"
              />
              <span class="title-card">{{
                $utils.convertMoney(payment_status?.bounty_value)
              }}</span>
            </p>
            <p class="time">
              {{ company_bounty_payment_date }}
            </p>
          </div>
        </div>
      </div>
      <div
        v-if="payment_status?.hacker_bounty_status == 'done'"
        class="d-flex align-self-start h-profile"
      >
        <div class="v-line d-flex align-items-stretch">
          <span class="pb-4"></span>
        </div>
      </div>

      <div
        v-if="payment_status?.hacker_bounty_status == 'done'"
        class="d-flex align-self-start h-profile-circle"
      >
        <div class="d-flex w-100 align-items-center">
          <div
            class="d-flex flex-row justify-content-between align-items-start w-100"
          >
            <p class="d-flex align-items-center">
              <a
                href=""
                class="mr-1 title-card"
                v-text="hacker_username ? hacker_username : $store.getters['getUser'].username"
              ></a>
              <span class="description-status mr-1" v-text="$ml.get('paymentReceived')">recebeu um pagamento  &nbsp;</span>
              <img
                src="../../../src/assets/icons/long-arrow-right.svg"
                class="ico-15"
              />
              <span class="title-card">{{
                $utils.convertMoney(payment_status?.bounty_value)
              }}</span>
            </p>
            <p class="time">
              {{ hacker_bounty_payment_date}}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const moment = require("moment");
export default {
  name: "PayRequestCard",
  props: {
    payment_status: {
      type: Object,
      required: true,
      default: Object,
    },
    hacker_username: {
      type: String,
      required: false,
      default: String,
    },
  },
  
  data() {
    return {
      hacker_bounty_payment_date: moment(this.payment_status?.hacker_bounty_payment_date).format('DD/MM/YYYY'),
      company_bounty_payment_date: moment(this.payment_status?.company_bounty_payment_date).format('DD/MM/YYYY')
    };
  },
};
</script>
<style scoped>
.card-info {
  padding: 10px;
  background: rgb(255, 255, 255);
  border: 1px solid #fff;
  border-radius: 3px;
  box-shadow: 0 10px 22px rgba(18, 38, 63, 0.06),
    0 2px 8px rgba(18, 38, 63, 0.1);
  max-width: 782px;
  margin-left: 20px;
}
.description-status{
  font-size: 14.4px !important;
  color: #333 !important;
}
.title-card{
  color: #730BA9 !important;
  font-size: 0.9rem !important;
}
</style>
